import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import Seo from "@/lib/seo";
import { useAuth } from "@/lib/auth";
import Navbar from "@/components/Navbar";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const user = await login(email, password);
      toast.success("Welcome back");
      const dest = loc.state?.from?.pathname || (user.role === "admin" ? "/admin" : "/dashboard");
      nav(dest);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <>
      <Seo title="Log In" path="/login" description="Log in to your Asylum Entertainment artist dashboard to manage releases, analytics and payouts." />
      <Navbar />
      <div className="min-h-[calc(100vh-73px)] grid lg:grid-cols-2">
        <div className="hidden lg:block relative border-r border-zinc-800 bg-zinc-950">
          <div className="absolute inset-0 flex flex-col justify-between p-12">
            <div className="text-[10px] tracking-[0.3em] uppercase text-red-500">— Asylum Entertainment</div>
            <div>
              <h2 className="font-display text-5xl uppercase tracking-tighter leading-[0.95] mb-4">
                Welcome<br />back to <span className="text-red-600">the room.</span>
              </h2>
              <p className="text-zinc-500 text-sm">Sign in to manage your releases, royalties, and roster.</p>
            </div>
          </div>
        </div>
        <div className="flex items-center justify-center p-8 lg:p-16">
          <form onSubmit={submit} className="w-full max-w-md" data-testid="login-form">
            <div className="text-[10px] tracking-[0.3em] uppercase text-red-500 mb-4">— Sign In</div>
            <h1 className="font-display text-4xl uppercase tracking-tighter mb-10">Log In.</h1>
            <label className="block mb-6">
              <div className="text-[10px] tracking-[0.2em] uppercase text-zinc-500 mb-2">Email</div>
              <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" required data-testid="login-email"
                className="w-full bg-transparent border border-zinc-800 px-4 py-3 text-sm focus:border-red-600 focus:outline-none focus:ring-0" />
            </label>
            <label className="block mb-8">
              <div className="text-[10px] tracking-[0.2em] uppercase text-zinc-500 mb-2">Password</div>
              <input value={password} onChange={(e) => setPassword(e.target.value)} type="password" required data-testid="login-password"
                className="w-full bg-transparent border border-zinc-800 px-4 py-3 text-sm focus:border-red-600 focus:outline-none focus:ring-0" />
            </label>
            <button type="submit" disabled={busy} data-testid="login-submit"
              className="w-full bg-red-600 text-white py-4 text-sm tracking-[0.2em] uppercase btn-brutal btn-brutal-red disabled:opacity-50">
              {busy ? "Signing in..." : "Sign In"}
            </button>
            <div className="mt-6 text-sm text-zinc-500">
              No account? <Link to="/signup" className="text-red-500 hover:underline" data-testid="login-to-signup">Sign up</Link>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
